//import { API_URL, API_V2_URL, API_QMS_URL, BUCKET_NAME, API_FR_URL } from "@env"

export class Serviceurls {

    // static DOMAIN = "https://dev.api.emedhub.in/v2/";
    // static BASE_DOMAIN = "https://dev.api.emedhub.in/";
    static WEB_SOCKET_DOMAIN = "wss://api.emedhub.in/ws/";


    static UAT_DOMAIN = "https://uat.v3.api.emedhub.in/v2/"
    static UAT_BASE_DOMAIN = "https://uat.v3.api.emedhub.in/"

    // beta or line url ----
    // api.emedhub.in
    // static UAT_DOMAIN = "https://api.emedhub.in/v2/"
    // static UAT_BASE_DOMAIN = "https://api.emedhub.in/"

    static DOMAIN = this.UAT_DOMAIN;
    static BASE_DOMAIN = this.UAT_BASE_DOMAIN;

    // user role
    static REG_EX_MOBILENO = /[^.[0-9]]*/
    static ROLE_FO = "FO";
    static ROLE_DOCTOR = "doctor";
    static ROLE_OPT = "OPHTHALMOLOGY";
    static ROLE_OPTOMETRY = "OPTOMETRY";
    static ROLE_COUNSELLOR = "COUNSELLOR"

    static LANGUAGES = this.DOMAIN + "languages/"
    static GET_STATE = this.BASE_DOMAIN + "pharmacy/states/";
    static API_SIGN_IN = "auth/login/";
    static HOME_APPOINTMENTS = "doctor/appointments/list/";
    static REG_EX_MOBILENO = /[^.[0-9]]*/

    static GET_MODULES_LIST = "auth/user/linked/modules/"
    static MODULES_DATA_GET = 'auth/user/token/'
    static MODULE_TYPE_LIST_GET = "auth/overall/module/list/"
    static LOGIN_RESET_PASS = 'auth/password/change/'

    //FO - Home screen API
    static FO_HOME_OP = "fo/appointment/list/"
    static FO_HOME_OP_STATUS = "fo/appointment/status/update/"
    static OP_TO_IP_MOVE = "fo/patient/appointment/ip-conversion/"
    static FO_IP_OP_PATIENT_TAG_CHANGE_NORMAL = 'ip/patient/tag/update/'
    static FO_CONFIG_OPSPECIALIZATION = "fo/specialization/"
    static DOC_TRANSFER_REQUEST = "doctorv4/appointment/transfer-request/"
    static FO_BADGE_COUNT_GET = 'fo/appointment/request/count/'
    static FO_HOME_OP_POV_UPDATE = "fo/appointment/update/pov/"

    static SARAS_DOC_VISIT_REPORT_GET = "doctorv4/patient/visit-report/print/"

    //FO - Custom Config
    static CUSTOM_CONFIG = "fo/custom-config/"

    // Doctor Websocket API
    static DOC_EMERGENCY_WEBSOCKET = 'emergency-update/'
    static DOC_RUNNINGLATE_WEBSOCKET = 'running-late/'
    static DOC_OUTOFOFFICE_WEBSOCKET = 'doctor/out-of-office/'
    static DOC_PATIENTCALL_WEBSOCKET = 'patient-call/'
    static FO_CALLPATIENT_WEBSOCKET = 'fo/call-update/'
    static TOKENSCREEN_WEBSOCKET = 'token-screen/'

    // Doctor Layout API
    static DOC_DOCTOR_NOTES_LAYOUT = 'doctorv4/notes/layout/'

    //aws url
    static AWS_URL_GET = "fo/aws-s3/url/"

    // Fo Appointment Create
    static FO_CREATE_APPOINTMENT = "fo/patient/appoinment/"
    static OP_PATIENT_DEMO_UPDATE = "op/patient/update/"
    static FO_PATIENT_SEARCH = "fo/patient/search/"
    static FO_GET_APPOINMENT_DETAILS = "fo/appointment/details/"
    static FO_APPOINT_REQUESTS = "fo/appointment/request/list/"
    static FO_TELE_APPOINTMENT_REQUEST = "fo/appointment/request/"
    static FO_PATIENT_APPOINTMENT_DETAILS = "fo/appointment/details/"
    //FO - Patient Create
    static FO_PATIENT_CREATE = 'fo/patient/create/'
    static FO_PATIENT_UPDATE = 'fo/patient/update/'
    static FO_PATIENT_APPOINTMENT = 'fo/patient/appoinment/'

    static FO_INSURANCE_LIST = "fo/insurance/list/"
    static FO_CONFIG_CORPORATE = "fo/corporate/detail/"
    static FO_PATIENT_LAST_VISIT_DATE_AND_BALANCE_AMOUNT = "fo/patient/outstanding/visits/"
    static FO_NOTIFICATION_GET = 'fo/home/notifications/'
    static DOC_REFERRAL_DOCTOR = 'fo/referral/doctor/'

    // Common Print
    static DOC_SETTING_CONFIG = 'doctorv4/configurations/'
    static PRINT_PRESCRIPTION = "doctorv4/prescription-create/new"
    static MEDICAL_RECORD_PRINT = "fo/medical/record/"

    //Doctor Notes,Op card and prescription Print
    static OP_CUSTOMIZED_CARD_PRINT = "fo/custom-barcode/print/"
    static OP_CARD_PRINT = "fo/barcode/print/"
    static OP_PATIENT_DATA_PRINT = "fo/op/patient/data/"
    static OP_DOCTOR_VISIT_REPORT_PRINT = "fo/doctor/notes/print/"
    static OP_DOCTOR_PRECSCRIPTION_PRINT = "fo/medication/print/"
    static OP_PRES_TEMPLATE = "fo/prescription/sheet/"


    //NEW Bill print 
    static NEW_OP_INVOICE_PRINT = "billing/op-service-bill/print/"
    static NEW_OP_DETAILED_BILL_PRINT = "billing/op-detail-bill/print/"
    static NEW_OP_SUMMARY_BILL_PRINT = "billing/op-summary-bill/print/"

    // IP API'S
    static IP_COMPLAINTS_DATASET = "ip/reason/"

    //DOCTOR MODULE API STARTS =========>
    static DOC_PATIENT_DETAIL_GET = 'doctorv4/patient/detail/'
    static DOC_FOLLOWUP_GET = 'doctorv4/opt/reviewplan/followup/'
    static DOC_APPOINTMENT_REQUEST = 'doctorv4/appointment/request/'
    static DOC_DOCTOR_NOTES_PLAN_GET = 'doctorv4/procedure/'
    static DOC_SESSION_LIST = 'doctorv4/session/list/'
    static DOC_SCHEDULE_OUTOFOFFICE = 'doctorv4/mark/out-of-office/'
    static DOC_SCHEDULE_DATA_GET = 'doctorv4/schedule/list-view/'
    static DOC_ROOMNO_CONFIG = 'doctorv4/room/detail/'
    static DOC_SESSION_CONFIG = 'doctorv4/session/config/'
    static DOC_CLINIC_LIST_GET = 'doctorv4/clinic/'
    static DOC_UNLOCK_DOCTOR_NOTES = "doctorv4/unlocked/notes/"
    static DOC_PRINT_CONFIG = 'doctorv4/configurations/'
    static DOC_APPOINTMENT_LIST = 'doctorv4/appointment/list/'
    static DOC_HISTORY_REPORT_PRINT = 'doctorv4/patient/history/print/'
    static DOC_IMMUNIZATION_PRINT = 'doctorv4/paediatric/immunization/'
    static DOC_DOCTOR_NOTES_PRINT = 'doctorv4/print/visit-report/'
    static DOC_NOTES_AUTO_LOCK = "doctorv4/appointment/auto-lock/"
    static DOC_APPOINTMENT_STATUS = 'doctorv4/appointment/status/'
    static DOC_WENT_FOR_EMERGENCY = "doctorv4/emergency/update/"
    static DOC_APPOINTMENT_STATUS_UPDATE = 'doctorv4/appointment/status/update/'
    static DOC_REFERRAL_SOURCE = 'doctorv4/referral/source/'
    static DOC_PATIENT_CREATION = 'doctorv4/patient/create/'
    static DOC_PATIENT_APPOINTMENT = 'doctorv4/appointment/create/'
    static ADD_REFERRAL_NOTES_TEMP = 'doctorv4/forms/referral/template/'
    static DOC_FORM_REFERRAL_POST = 'doctorv4/forms/referral/referral_doctor_notes/'
    static DOC_FORM_REFERRAL_GET = 'doctorv4/forms/referral/referral_notes_items/'
    static DOC_FORM_REFERRAL_DOCTOR = 'doctorv4/forms/referral/doctor/'
    static DOC_MEDICAL_CERTFICATE_GET = 'doctorv4/forms/medicalform/notes/'
    static DOC_FITNESS_CERTFICATE_GET = 'doctorv4/forms/fitnessform/notes/'
    static DOC_DEATH_CERTFICATE_DETAILS_GET = 'doctorv4/forms/deathcertificate/upload/'
    static DOC_PATIENT_DOCUMENT_GET = 'doctorv4/patient/doc-upload/'
    static DOC_MEDICAL_PROBLEM_GET = 'doctorv4/problems/'
    static DOC_MEDICAL_HISTORY = 'doctorv4/patient/medical/history/'
    static DOC_HOSPITALIZATION_HISTORY = 'doctorv4/patient/hospital/history/'
    static DOC_HOSPITALIZATION_HISTORY_DELETE = 'doctorv4/delete/hospitalization/history/'
    static DOC_SOCIAL_HISTORY = 'doctorv4/patient/social/history/'
    static DOC_FAMILY_HISTORY = 'doctorv4/patient/family/history/'
    static DOC_FAMILY_HISTORY_DELETE = 'doctorv4/delete/family/history/'
    static DOC_DISCHARGE_SUMMARY_GET = 'doctorv4/patient/discharge_summary/'
    static DOC_DOCTOR_CLINIC_LIST_GET = 'doctorv4/clinic/doctors/'
    static DOC_TEST_SUGGESTION_GET = "doctorv4/patient/test-service/list/"
    static DOC_DOCTOR_VISIT_REPORT = 'doctorv4/visit/report/'
    static DOC_RUNNINGLATE_WEBSOCKET = 'running-late/'
    static DOC_OUTOFOFFICE_WEBSOCKET = 'doctor/out-of-office/'
    static DOCTOR_NOTES_PRINT = "doctorv4/print/visit-report/"
    static DOC_DOCTOR_TEST_REPORT = 'doctorv4/test/report/'
    static SCHEDULE_POST_API = "fo/doctor/schedule/"
    static DOC_DOCTOR_TEST_REPORT_POST = 'doctorv4/patient/test-reports/upload/'
    static DOC_LAB_HISTORY_TEST_REPORT_DB = "doctorv4/lab/test-history/"
    // Registration Form API's
    static FO_QR_ENTRY_LIST = 'fo/qr-entry/list/'

    //FO Hospital Configration
    static FO_CONFIG_OPSPLGET = "fo/specilation/type/"

    //FO - OP Service Configuration API
    static FO_CONFIG_OPDOCTORNAME = "fo/doctor/name/"
    static FO_PATIENT_COUNT_DETAILS_GET = "fo/appointment/status-count/"
    static SCHEDULE_TIME_GET = "doctorv4/slot/list/"
    static FO_CONFIG_OPPATIENTTAG = "fo/patient/tag/"
    static FO_CONFIG_OPAPPOINTMENT = "fo/appointment/type/"
    static FO_POV_LIST = "fo/pov/"
    static FO_POV_LIST_MASTERS = "fo/clinic/purpose-of-visit/"
    static VITALS_CONFIGURATION = "fo/vital/config/"
    static FO_CONFIG_OPTOKENPREFIX = "fo/prefix/config/"
    static FO_NEW_OP_SERVICE_CONFIG = 'fo/service/config/new/'
    static AUTOBILLING_GET = "fo/hospital/config/"

    //FO - Nurse Notes
    static FO_NURSE_NOTES = "fo/patient/vital/"
    static FO_STAFF_LIST = "fo/staff/list/"
    static OP_NURSE_NOTES = "fo/nurse-notes/"
    static OP_NURSE_HIS = "fo/nurse-notes/history/"

    //FO - Demographics config
    static FODemographicsLayout = 'fo/field/order/'
    static SUR_NOTES_LAYOUT = "ip/surgery/notes/"
    static IP_TEMPLATE_SUR_NOTE = "ip/surgery/notes/template/"

    //FO - Referral Configuration API
    static FO_CONFIG_REF_SOURCE = "fo/referral/source/"
    static FO_CONFIG_REF_DOCTOR = "fo/referral/doctor/"
    static FO_CONFIG_REF_Config = "fo/referral/staff/"

    //Ip Barcode Label Print

    //corporate details
    static GET_PATIENT_BILLING_DEATILS = "fo/corporate/ip/bills/";
    static INSURANCE_MASTER = 'fo/insurance-list/'
    static GET_CORPORATE_CLAIM_DETAILS = "fo/corporate/claim-detail/"

    // static IP_BARCODE_PRINT = "ip/label/print/"
    static COMMON_BARCODE_PRINT = "fo/patient/label/print/"
    static FO_APPOINTMENT_PRINT = "fo/appointment/list/print/"

    //QMS
    static QMS_CONFIG = 'fo/qms/config/'
    static FO_DOC_QUEUE_GET = 'fo/drqueue/list/'

    // IP Admission Create
    static IP_PATIENT_CREATE = "ip/patient/create/"
    static IP_ADMISSION_DETAILS = "ip/admission/create/"
    static IP_ADVANCE_PAYMENT = "ip/advance/payment/"

    // IP Print
    static IP_DIS_SUM_PRINT = "ip/discharge/summary/"

    //FO - Patient Details
    static FO_DOCTOR_VISIT_REPORT = "fo/visit/report/"
    static NEW_DOC_NOTES_VISIT_REPORT_PRINT = 'doctorv4/opt/pdf/visit-report/'
    static FO_TEST_REPORT = "fo/test/report/"
    static FO_TEST_REPORT_DELETE = "doctorv4/patient/test-reports/upload/"

    // IP Patients Details
    static FO_PATIENT_DETAILS_NEW = "ip/patientheader/new/"

    //FO IP Clinical Notes
    static FO_IP_CLINICAL_NOTES_VITAL = 'ip/inpatient/vitals/'
    static FO_IP_HISTORY = "ip/clinicnotes/history/"

    // IP Services
    static IP_NEW_SERVICE_CONFIGURATION = 'ip/service/configuration/'
    static IP_COMPLAINTS_DATASET_MASTERS = "ip/clinic/reason/"

    //Fo - Sms Configuration 
    static FO_SMS_REQUEST = "fo/sms/request/"
    static FO_SMS_CONFIG = "fo/sms/configuration/"
    static FO_SMS_CONFIG_ALERT_REMOVE = "fo/ignore/sms-threshold/"

    // Billing Transactions
    static DAY_END_USER_DETAIL_GET = "fo/user/list/config/"

    //MRD URLS
    // static MRD_CATEGORY_GET_POST = "mrd/category/"
    // static MRD_RACK_GET_POST = "mrd/rack/"
    static MRD_DEPARTMENT_GET_POST = "mrd/department/"
    static MRD_CONSULT_ROOM_GET_POST = "mrd/consultant-room/"
    static MRD_NURSE_STATION_GET_POST = "mrd/nurse-station-room/"

    // IP - Room Configurations
    static HOSPITAL_CONFIG = "ip/hospital/config/"
    static WARD_CONFIG = "ip/ward/config/"
    static BED_CONFIG = "ip/bed/config/"
    static USER_ROOM_TYPE = "ip/room/type/"
    static HISTORY_DATA = "ip/history/data/"
    static BED_SELECT = "ip/bed/avail/detail/"
    static BED_AVAIL = "ip/report/beds/"
    static IP_ROOM_BOOKING_DETAILS = "ip/room/booking-details/"
    static IP_PATIENT_RESERVE_ROOM = "ip/patient/reserve-room/"

    // Credit Details
    static GET_MASTER_BANK_DATA = "core/bank/details/"

    // Ayurveda Module API
    static AYURVEDA_THERAPIST_MASTER = 'ayurveda/employees/'
    static AYURVEDA_THERAPIST_GRADES = 'ayurveda/grades/'
    static AYURVEDA_TREATMENT_MASTER = 'ayurveda/treatments/'
    static AYURVEDA_FACILITIES_MASTER = 'ayurveda/facilities/'
    static AYURVEDA_AMENITIES_MASTER = 'ayurveda/amenities/'
    static AYURVEDA_SYMPTOMS_MASTER = 'ayurveda/symptom-master/'
    static AYURVEDA_STATUS_MASTER = 'ayurveda/status-master/'
    static AYURVEDA_THERAPY_MAPPING = 'ayurveda/employee-treatment-mapping/';
    static AYURVEDA_EXPECTED_OUTCOME_MASTER = 'ayurveda/expected-outcome-master/'
    static AYURVEDA_AREA_MASTER = 'ayurveda/area-master/'
    static AYURVEDA_CATEGORY_MASTER = 'ayurveda/categories/'
    static AYURVEDA_DISEASE_MASTER = 'ayurveda/disease/'
    static AYURVEDA_SYSTEM_MASTER = 'ayurveda/system/'
    static AYURVEDA_SUBDIVISION_MASTER = 'ayurveda/subdivisions/'
    static AYURVEDA_PART_MASTER = 'ayurveda/part/'
    static AYURVEDA_ELEMENT_MASTER = 'ayurveda/element/'
    static AYURVEDA_THERAPY_ROOM_MASTER = "ayurveda/therapy-room/"
    static AYURVEDA_COUPON_MASTER = "ayurveda/coupon-master/"
    static AYURVEDA_DIAGNOSIS_MASTER = 'ayurveda/diagnosis/'
    static AYURVEDA_THERAPY_COMBINATIONS = "ayurveda/therapy-combination/"
    static AYURVEDA_THERAPY_CHECKLIST_MASTER = "ayurveda/therapy-checklist/"
    static AYURVEDA_TREATMENT_CREATE_SLOT = "ayurveda/treatment/create-slot/"
    static MEDICINE_MAPPING_CONFIGURATION = "ayurveda/treatment-medicines/"

    //New Master Configuration
    static MODULE_LIST = 'billing/service/summary/'
    static FO_LAB_SEARCH = 'billing/lab/service/'
    static NEW_DEPARTMENT_MASTER = 'billing/service/config/'
    static CONFIGURATION_SERVICE_SEARCH = 'billing/service/config/search/'
    static NEW_TEMPLATE_CONFIGURATION = 'billing/template/config/'
    static NEW_PACKAGE_CONFIGURATION = 'billing/package/config/'
    static HEAD_CONSULTATION_LIST = 'billing/consultation/service/'
    static HEAD_TREATMENT_LIST = 'billing/treatment/service/'
    static NEW_INSURANCE_PACKAGE_CONFIG = "billing/insurance/package/config/"
    static NEW_INSURANCE_PACKAGE_MASTER = "billing/insurance/package/config/master/"
    static FO_NEW_CORPORATE_SERVICE_CONFIG = "billing/corporate/service/"

    // New Billing API's
    static NEW_BILLING_OP_TEMPLATE_LIST = 'billing/template/list/'
    static NEW_BILLING_OP_TEMPLATE_GET = 'billing/template/data/'

    //New auto billing 
    static NEW_AUTO_BILLING_LIST = "billing/auto-bill/services/"
    static NEW_AUTO_SUMMARY = "billing/auto-bill/module-service/"
    static NEW_AUTO_BILLING_GET = "billing/services/auto-billing/"

    // Ayurveda Doctor Notes API
    static AYURVEDA_PAST_COMPLAINTS = "doctorv4/past-complaints/"
    static AYURVEDA_EXPECTED_OUTCOME = "doctorv4/status-expected-outcomes/"
    static AYURVEDA_NEW_COMPLAINTS = "doctorv4/new-presenting-complaints/"
    static AYURVEDA_SYSTEMIC_EXAMINATION = "doctorv4/systemic-examinations/"
    static AYURVEDA_DOCTOR_DIAGNOSIS = "doctorv4/ayurvedic-diagnosis/"
    static AYURVEDA_ALLOPATHIC_DIAGNOSIS = "doctorv4/allopathic-diagnosis/"
    static AYURVEDA_ALLOPATHIC_MEDICATION = "doctorv4/current-allopathic-medications/"
    static AYURVEDA_GENERAL_ADVICE = "doctorv4/patient/general-advice/"
    static AYURVEDA_PATIENT_CATEGORIES = "doctorv4/patient/category-new/"
    static AYURVEDA_PATIENT_CATEGORIES_SUGG = "doctorv4/patient/category-suggestion/"
    static AYURVEDA_LAST_VISIT_RECORDS = "doctorv4/last-visit-records/"
    static AYURVEDA_DOC_INVESTIGATION = "doctorv4/patient/test-service/create/"
    static AYURVEDA_TREATMENT_PLAN = "doctorv4/treatment-plans/"
    static AYURVEDA_DRUG_SEARCH = "doctorv4/drug-search/new/"
    static AYURVEDA_DRUG_DETAILS = "doctorv4/drug-detail/new/"
    static AYURVEDA_PHARMACY_LIST = "doctorv4/prescription/pharmacy-list/"
    static AYURVEDA_FAVOURITE_LIST = "doctorv4/favorite-prescription/new/"
    static AYURVEDA_PREVIOUS_HISTORY = "doctorv4/previous-prescription/new/"
    static AYURVEDA_PRESCRIPTION_LIST = "doctorv4/prescription-create/new/"
    static AYURVEDA_PREVIOUS_PRESCP_HISTORY = "doctorv4/previous-prescription/new/"
    static AYURVEDA_FREQUENT_DRUG_LIST = "doctorv4/frequent-prescription-drugs/new/"
    static AYURVEDA_PRESCRP_TEMPLATE = "doctorv4/prescription-template/new/"
    static AYURVEDA_PRESCRIP_TRANSMIT = "doctorv4/prescription-transmit/new/"
    static AYURVEDA_DOC_PAINCHART_GET = "doctorv4/patient/pain-chart/"
    static AYURVEDA_DOC_ICD_DIAGNOSIS_GET = "doctorv4/patient/icd-diagnosis/"
    static AYURVEDA_DOC_ICD_DIAG_FREQ_GET = "doctorv4/patient/icd-diagnosis/frequent/"
    static AYURVEDA_DIET_PLAN = "doctorv4/patient/diet-plan/"
    static AYURVEDA_DOC_PREVIOUS_ICD_GET = "doctorv4/patient/icd-diagnosis/history/"
    static AYURVEDA_TENTATIVE_PLAN = "doctorv4/patient/treatment-recommendation/";
    static DOC_REGISTRY_ICD_SEARCH = 'doctorv4/icd/search/'
    static DOC_VITALS_GET = 'doctorv4/save/patient-vitals/'
    static DOC_CARE_PLAN = 'doctorv4/patient/care-plan/'

    // IP Doctor Notes (same base paths, use ip_admission_id & clinic_id & doctor_id)
    static SAR_IP_DOC_NOTES_DIAGNOSIS = "doctorv4/ip/patient/icd-diagnosis/"
    static SAR_IP_DOC_NOTES_DIAGNOSIS_SUGG_GET = "doctorv4/ip/patient/icd-diagnosis/frequent/"

    // AYURVEDA PROCESS FLOW
    static AYURVEDA_SCHEDULER = ""
    static AYURVEDA_COUNSELLOR = "ayurveda/treatment-plan-list/"
    static AYURVEDA_COUNSELLOR_APPROVAL_LIST = "ayurveda/doctor/approval-list/"
    static AYURVEDA_COUNSELLOR_WALKIN = "ayurveda/counsellor/walkin/"
    static AYURVEDA_WALKIN_APPOINTMENT_LIST = "ayurveda/walkin/appointment-list/"
    static AYURVEDA_ADVANCE_PAYMENT = "billing/treatment/plan/advance/payment/"
    static TREATMENT_PLAN_GET_POST = "ayurveda/treatment-plan-post/"
    static AYURVEDA_THERAPY_SEARCH = "ayurveda/treatment-search/"
    static AYURVEDA_TREATMENT_MEDICINE_GET = "ayurveda/treatment-details/"
    static AYURVEDA_SCHEDULER_VIEW = "ayurveda/scheduler/view/"
    static AYURVEDA_SCHEDULE_LIST = "ayurveda/scheduler/therapy-scheduling/"
    static AYURVEDA_SCHEDULE_LIST_UPDATE = "ayurveda/scheduler/therapy-scheduling/"
    static AYURVEDA_SCHEDULER_LIST_VIEW = "ayurveda/scheduler/schedules-list/"
    static AYURVEDA_AVAILABLE_THERAPISTS = "ayurveda/available-therapists/"
    static AYURVEDA_SCHEDULING_TREATMENT = "ayurveda/scheduler/scheduling-treatment/"
    static AYURVEDA_MEDICINE_PREPARE_DRUG_DETAILS = "ayurveda/drug/details/"
    static AYURVEDA_MEDICINE_PREPARE_DRUG_SEARCH = "ayurveda/drug/search/"
    static AYURVEDA_CREATION_DRUG_SEARCH = "ayurveda/creation/drug-search/"
    static AYURVEDA_MEDICINE_CREATION = "ayurveda/medicine-creation/"
    static AYURVEDA_WALKIN_APPOINTMENT_STATUS_UPDATE = "ayurveda/walkin/appointment-status-update/"
    static AYURVEDA_MEDICINE_PREPARATION_TREATMENT = "ayurveda/medicine-preparation/treatment/"
    static AYURVEDA_THERAPY_CHECKLIST = "ayurveda/therapy/check-list/"
    static AYURVEDA_JOB_CARD_PRINT = "ayurveda/job-card-print/"

    static AYURVEDA_WALKIN_ORDER = "ayurveda/walkin-order/"
    static AYURVEDA_WALKIN_ORDER_VIEW = "ayurveda/walkin/admission/order/view/"
    static AYURVEDA_PATIENT_HEADER = "ayurveda/walkin/patientheader/new/"
    static AYURVEDA_PATIENT_BILLS = "ayurveda/walkin/patient/bills"
    static AYURVEDA_PATIENT_RECEIPTS = "ayurveda/walkin/patient/receipts/"
    static AYURVEDA_PENDING_ORDER = "ayurveda/walkin/pending-order/"
    static AYURVEDA_APPROX_VALUE = "ayurveda/walkin/bill-value/"
    static AYURVEDA_FINAL_ORDER_GET = "ayurveda/walkin/final-order/"
    static AYURVEDA_FINAL_BILL_POST = "ayurveda/walkin/billing/"
    static AYURVEDA_RECEIVE_WALKIN_PAYMENT = "ayurveda/receive/walkin_payment/"
    static AYURVEDA_WALKIN_FINAL_BILL_GEN = "ayurveda/walkin/final-bill-gen/"
    static AYURVEDA_WALKIN_SERVICE_BILL_PRINT = "ayurveda/walkin-service-bill/print/"
    static AYURVEDA_WALKIN_APPROX_BILL_PRINT = "ayurveda/approx/bill/print/"
    static AYURVEDA_WALKIN_DETAILED_BILL_PRINT = "ayurveda/walkin-detailed-print/"
    static AYURVEDA_WALKIN_SUMMARY_BILL_PRINT = "ayurveda/walkin-summary-bill/print/"

    static AYURVEDA_WALKIN_VITALS = "ayurveda/walkin/vitals/"
    static AYURVEDA_WALKIN_NURSE_NOTES = "ayurveda/walkin/nursenotes/"
    static AYURVEDA_WALKIN_NUTRITION_CHART = "ayurveda/walkin/nutrition/chart/"
    static AYURVEDA_WALKIN_PAIN_CHART = "ayurveda/walkin/painchart/"
    static AYURVEDA_WALKIN_NOTES_ORDER = "ayurveda/walkin/notes/order/"
    static AYURVEDA_WALKIN_CLINIC_NOTES_HISTORY = "ayurveda/clinicnotes/history/"
    // Ayurveda Therapist Daily Report
    static AYURVEDA_THERAPIST_GET = "ayurveda/walkin/appointment-list/"
    static AYURVEDA_THERAPIST_POST = "ayurveda/walkin/appointment-status-update/"
    // Lab result
    static LAB_PATIENT_RESULT_PRINT = "lab/test/report/print/"
    static TEST_TRANSMIT = 'doctorv4/order/create/'

    // lab module api 
    static LAB_ANALYSER_MASTER = "lab/analyser/master/"
    static LAB_ANTIBIOTIC_MASTER = "lab/antibioticmaster/"
    static GET_LAB_DEPARTMENT_MASTER = 'lab/department/master/'
    static GET_LAB_CONTAINER_MASTER = 'lab/container/master/'
    static GET_LAB_SPECIMEN_MASTER = 'lab/specimen/master/'
    static GET_LAB_METHOD_MASTER = 'lab/methodmaster/'
    static LAB_ORGANISM_MASTER = "lab/organismmaster/"
    static LAB_ORGANISM_VS_ANTIBIO_MASTER = "lab/organism/vs/antibiotic/"
    static LAB_REPORT_PRINT_CONFIG = "lab/report/print-configuration/"
    static LAB_REPORT_PRINT_CONFIG_PREVIEW = "lab/test/report/print/"
    static LAB_PRODUCT_UNIT = "lab/product/unit/list/"
    static NEW_LAB_RESULT_CONFIGURATION = 'lab/result-config/'
    static LAB_ADD_NEW_TEST = 'lab/test/create/'
    static LAB_GRP_EDIT_DELETE = 'lab/group/edit/'
    static LAB_TEST_CONFIG_GET = "lab/test/config/"
    static LAB_TEST_GROUP_GET = "lab/test/labset/"
    static LAB_CONSUMABLES_LIST_GET = "lab/consumable/search/"
    static LAB_CONSUMABLES_GET = "lab/consumable/service/map/"
    static LAB_PATIENT_DETAILS_GET = "lab/patient/demographics/"
    static LAB_REFERRED_DOCTOR = "lab/referral/doctor/";
    static LAB_OUTSOURCE_CONFIG = "lab/outsource/config/"
    static LAB_OUTSOURCE_MAPPING = "lab/outsource/mapping/"
    static LAB_E_SIGNATURE_CONFIG = "lab/esign/"
    //aws url
    static AWS_URL_GET = "fo/aws-s3/url/"
    static LAB_ESIGN_UPLOAD = "fo/aws-s3/url/"

    // NEW BILLING API
    static NEW_BILLING_OP_SERVICE_GET = 'billing/services/'

    static OP_PENDING_ORDER_LIST = 'billing/accept/order/pending/view/'
    static PENDING_ORDER_LIST_LAB = 'billing/lab/accept/order/pending/view/'
    static PENDING_ORDER_LIST_RAD = 'billing/rad/accept/order/pending/view/'
    static PENDING_ORDER_LIST_INVESTIGATION = 'billing/investigation/accept/order/pending/view/'

    static NEW_BILLING_OP_TEMPLATE_LIST = 'billing/template/list/'
    static NEW_BILLING_OP_TEMPLATE_GET = 'billing/template/data/'
    static NEW_BILLING_PATIENT_SEARCH = 'billing/patient/search/'
    static NEW_BILLING_PATIENT_OP_IP_NUM_LIST = 'billing/module/search/'
    static NEW_BILLING_OP_POST = 'billing/op/billing/'
    static NEW_BILLING_SAVED_BILL_GET = 'billing/op/saved/bills/'
    static DOC_TEST_LABTEST = 'billing/lab/test/'
    static DOC_TEST_RADTEST = 'billing/radiology/service/'
    static DOC_TEST_POST = 'doctorv4/create/test/new/'
    static DOC_TEST_GET = 'doctorv4/tests/list/'
    static NEW_BILLING_OP_ORDER_LIST = 'billing/op/pending/order/'
    static NEW_BILLING_IP_ORDER_GET = 'billing/ip/pending/order/'
    static NEW_BILLING_FINAL_SETTLE_GET = 'billing/ip/final/order/'
    static NEW_BILLING_IP_SETTLEMENT = 'billing/ip/billing/'
    static FO_INTERNAL_CMT = "fo/appointment/comments"
    // NEW RADIOLOGY API
    static TEST_TRANSMIT = 'doctorv4/order/create/'
    static IP_TEST_POST = 'ip/notes/order/'
    // NEW RADIOLOGY API
    static NEW_RAD_PATIENT_LIST = 'radiology/home/view/new/'
    static NEW_INVESTIGATION_PATIENT_LIST = 'investigation/home/view/new/'
    static NEW_RAD_SAVED_BILL_GET = 'radiology/saved/bill/view/new/'
    static NEW_RAD_PATIENT_BILLS_GET = 'radiology/bill/view/new/'
    static NEW_INVESTIGATION_PATIENT_BILLS_GET = 'investigation/bill/view/new/'
    static NEW_RAD_RECEIPT_BILL_GET = 'radiology/receipt/bill/list/new/'
    static NEW_BILLING_INDIVIDUAL_BILL_GET = 'billing/individual/bills/'
    static NEW_RAD_PATIENT_ORDER = 'radiology/patient/order/'
    static NEW_INVESTIGATION_PATIENT_ORDER = 'investigation/patient/order/'
    // NEW LAB API
    static NEW_LAB_STATUS_GET = "billing/lab/result/summary/"

    // NEW REPORT OP DETAILS
    static NEW_FO_REPORTS_SERVICE_DETAILED = "fo/op/service/detailed/"
    static NEW_FO_REPORTS_SERVICE_OVERVIEW = "fo/op/service/overview/"
    static NEW_DOCTOR_SHARE_REPORT = "fo/ipop/hospital/doctor/share/"
    static NEW_FO_REPORTS_CONSULT_WISE = "fo/op/consultation/report/"
    static NEW_FO_GST_REPORT = "fo/ipop/gst-report/new/"

    // NEW REPORT IP DETAILS
    static NEW_FO_REPORTS_IP_SERVICE_DETAILED = "ip/new-bill/service-detailed/"
    static NEW_FO_REPORTS_IP_SERVICE_OVERVIEW = "ip/new-bill/service-overview/"
    static NEW_FO_REPORTS_IP_LEGER_REPORT = "ip/new-bill/ledger-report/"
    static NEW_FO_REPORTS_IPADMISSIION = 'ip/new-bill/addmission-list/'

    // NEW OP Billing 
    static NEW_FO_PATIENT_APPOINTMENT_SAVED_GET = "billing/op/patient/drafts/"
    static NEW_FO_PATIENT_BILL_DETAILS_GET = "billing/op/patient/bills/"
    static NEW_FO_RECEIPT_BILL = "billing/op/patient/receipts/" // fo receipt bill

    // NEW IP BILLING
    static NEW_IP_PATIENT_INDIVIDUAL_SAVED_BILL = "billing/ip/patient/drafts/"
    static NEW_IP_PATIENT_INDIVIDUAL_BILLS = "billing/ip/patient/bills/"
    static NEW_IP_PATIENT_INDIVIDUAL_RECEIPT_Bill = "billing/ip/patient/receipts/"
    static NEW_IP_PREVIOUS_TEST_RECORDS = 'billing/discharge/summary/test-reports/'
    static NEW_IP_DISCHARGE_SUMMARY_TEST = "billing/inpatient/discharge/summery/labtest/"

    // NEW BILLING TRANSACTION
    static NEW_OVERALL_BILLS_GET = "billing/overall/"
    static NEW_CREDIT_BILLS_GET = "billing/credit-bill/"
    static NEW_COMPLETE_BILLS_GET = "billing/saved-bill/"
    static NEW_RECEIPT_REPORT = "billing/receipt/"
    static NEW_DAY_END_STATUS_GET = "billing/dayend/"
    static NEW_FO_ADVANCE_DETAIL = 'billing/advance/adjust/'
    static NEW_FO_RECEIPT_DETAIL = 'billing/receipt/detailed/'

    // NEW RAD REPORT
    static NEW_RAD_CENCUS_REPORT = 'radiology/census/report/new/'
    static NEW_RAD_PATIENT_REPORT = 'radiology/patient/service/report/new/'
    static NEW_RAD_CONSULTANT_WISE_REPORT = "radiology/consultation/rad/wise/report/new/"
    static NEW_RAD_TAT_REPORT = 'radiology/rad/tat/report/new/'

    static NEW_INVESTIGATION_CENCUS_REPORT = 'investigation/census/report/new/'
    static NEW_INVESTIGATION_PATIENT_REPORT = 'investigation/patient/service/report/new/'
    static NEW_INVESTIGATION_CONSULTANT_WISE_REPORT = "investigation/consultation/rad/wise/report/new/"
    static NEW_INVESTIGATION_TAT_REPORT = 'investigation/rad/tat/report/new/'

    // static NEW_RAD_SAVED_BILL_TRANS_GET = 'radiology/saved/bill/view/new/'

    static NEW_RAD_RECEIPT_BILL_TRANS_GET = 'radiology/receipt-bill/transactions/new/'
    static NEW_RAD_OVER_ALL_BILL_TRANS_GET = 'radiology/overall/transactions/new/'
    static NEW_RAD_CREDIT_BILL_TRANS_GET = 'radiology/credit-bill/transactions/new/'
    static NEW_RAD_DAY_END_BILL_TRANS_GET = 'radiology/day/end/new/'
    static NEW_RAD_SAVED_BILL_TRANS_GET = 'radiology/saved-bill/transactions/new/'
    static NEW_RAD_CANCEL_BILL_TRANS_GET = 'radiology/cancel-bill/transactions/new/'

    static NEW_INVESTIGATION_RECEIPT_BILL_TRANS_GET = 'investigation/receipt-bill/transactions/new/'
    static NEW_INVESTIGATION_OVER_ALL_BILL_TRANS_GET = 'investigation/overall/transactions/new/'
    static NEW_INVESTIGATION_CREDIT_BILL_TRANS_GET = 'investigation/credit-bill/transactions/new/'
    static NEW_INVESTIGATION_DAY_END_BILL_TRANS_GET = 'investigation/day/end/new/'
    static NEW_INVESTIGATION_SAVED_BILL_TRANS_GET = 'investigation/saved-bill/transactions/new/'
    static NEW_INVESTIGATION_CANCEL_BILL_TRANS_GET = 'investigation/cancel-bill/transactions/new/'

    // NEW LAB REPORT
    static NEW_LAB_BILL_REPORT = "lab/bill/report/new/";
    static NEW_LAB_RECEIPT_REPORT = "lab/receipt/report/new/"
    static NEW_LAB_CENSUS_REPORT_OLD = "lab/census/report/new/"
    static NEW_LAB_DAY_END_REPORT_GET = 'lab/dayend/report/new/'
    static NEW_LAB_INSURANCE_REPORT = "lab/receipt/insurance_report/new/"
    static NEW_LAB_SHARE_REPORT_GET = 'lab/share/report/new/'
    static NEW_POSITIVE_CENSUS_REPORT = "lab/census/pos_neg/new/"
    static NEW_LAB_PATIENT_REPORT = "lab/patient/report/new/"
    static NEW_LAB_CONSULTANT_WISE_REPORT = "lab/consultation/wise/lab/report/new/"
    static NEW_FO_REPORTS_CORPORATE_PATIENT = "fo/corporate/patient/report/new/"
    static NEW_LAB_PREVIOUS_REPORT = "lab/report/previous/new/"
    static LAB_CENSUS_REPORT = "lab/test/census/report"
    static LAB_DOCTOR_REPORT = "lab/doctor/report/"
    static REPORTS_OUTSOURCE_GET = "lab/report/outsource/"
    static LAB_GROUP_BASED_LIST_GET = "lab/group/report/"
    static LAB_TEST_BASED_LIST_GET = "lab/test/report/"
    static LAB_TAT_REPORT = "lab/tat/report/"

    // NEW PHARMACY REPORT
    static NEW_PHARMACY_RECEIPT_BILL_LIST = "billing/pharmacy/day-end/"
    static NEW_FO_CREDIT_BILLS_GET = 'billing/pharmacy/credit/collection/'

    //NEW Bill print 
    static NEW_OP_DETAILED_BILL_PRINT = "billing/op-detail-bill/print/"
    static NEW_OP_SUMMARY_BILL_PRINT = "billing/op-summary-bill/print/"
    static NEW_IP_INVOICE_PRINT = "billing/ip-service-bill/print/"
    static NEW_IP_PATIENT_BILL_DETAILED_PRINT = "billing/ip-detail-bill/print/"
    static NEW_IP_ADMISSION_BILL_SUMMARY_PRINT = "billing/ip-summary-bill/print/"
    static NEW_LAB_CREATE_BILL_COMPLETED_PRINT = "billing/lab-bill/print/"
    static NEW_RAD_BILL_POST = 'billing/rad-bill/print/'
    static NEW_INVESTIGATION_BILL_POST = 'investigation/bill/print/'
    static NEW_RECEIPT_INDIV_PRINT = "billing/receipt-bill/print/"
    static NEW_RAD_RESULT_PRINT = 'radiology/bill/service/print/new/'
    static NEW_INVESTIGATION_RESULT_PRINT = 'investigation/bill/service/print/new/'
    static NEW_RAD_BARCODE_PRINT = 'radiology/bill/barcode/new/'
    static NEW_INVESTIGATION_BARCODE_PRINT = 'investigation/bill/barcode/new/'
    static NEW_DAY_END_DETAILD = 'billing/dayend/detail/'
    static New_DOCTOR_NOTES_PRINT = "lab/test/print/new/"
    static NEW_BILLING_ISSUE_DRUG_PRINT = "billing/issued-drug/print/"

    // NEW FO URLS
    static NEW_GET_BILL_MODIFY_HISTORY = "billing/bill/log/"
    static NEW_SERVICE_LIST_REPORT = "billing/service/report/search/"
    static NEW_LAB_PACKAGE = "billing/package/report/search/"
    static NEW_LAB_PACKAGEWISE_REPORT = "lab/package/report/new/"
    static TEST_ORDER_RAD_PRINT = 'radiology/bill/service/print/new/'
    static NEW_CHANGE_CREDIT_PAYMENT = "billing/change/credit-type/"
    static NEW_CREDIT_ADJUSTMENT_REPORT = "fo/credit/settlement/new/"
    static NEW_CONSSESION_REPORT = "fo/concession/report/new/"

    static MODULE_TYPE_LIST_GET = "auth/overall/module/list/"

    // Cash Counter API's
    static CASH_COUNTER_BILL_SEARCH = 'billing/search/bill/'
    static CASH_COUNTER_PATIENT_SEARCH = 'billing/patient/search/'
    static CASH_COUNTER_MODULE_SEARCH = 'billing/module/search/'
    static CASH_COUNTER_BILLS_GET = 'billing/bills/'
    static CASH_COUNTER_COLLECTION_CARD = 'billing/collection/summary/'
    static CASH_COUNTER_POST = 'billing/receive/op_payment/'
    static CASH_COUNTER_POST_IP = 'billing/receive/ip_payment/'
    static CASH_COUNTER_ADVANCE_POST = 'billing/advance/receive/'
    static CASH_COUNTER_MODULES_GET = "billing/counter/list/"
    static NEW_BILING_CANCEL_REQUEST = 'billing/cancel/request/'
    static CASH_COUNTER_ADVANCE_POST_PHAR = 'pharmacy/advance-collection/'
    static IP_PATIENT_DETAILS_NEW = "ip/patientheader/new/"

    // pharmacy billing
    static PHARMA_BILLS_GET = "pharmacy/billing/"

    //New Common Billing
    static BILLING_CREATE_ORDER = 'billing/op/create/order/'
    static BILLING_CREATE_ORDER_IP = 'billing/ip/create/order/'
    static BILLING_CREATE_ORDER_LAB = 'billing/lab/create/order/'
    static BILLING_ORDER_LIST = 'billing/op/appointment/order/view/'
    static BILLING_ORDER_LIST_IP = 'billing/ip/admission/order/view/'
    static BILLING_OP_PENDING_ORDER_LIST = 'billing/op/pending/order/'
    static BILLING_IP_PENDING_ORDER_LIST = 'billing/ip/pending/order/'
    static BILLING_OP_CORPORATE_LIST = 'billing/search/corporate/'

    // Order Department wise card url
    static NEW_BILLING_ORDER_DEPTWISE = "billing/reports/deptwise/"
    static NEW_BILLING_BILL_REQUEST = 'billing/op/bill/request/'
    static NEW_BILLING_APPROVER_LIST = 'billing/approver-list/'
    static NEW_BILLING_PENDING_LIST = 'billing/request/list/'

    static RAD_APPOINTMENT_GET = 'lab/appointments/list/'
    static GET_IP_ORDERS_FOR_ADJUST = 'billing/ip/order/list/'
    static RT_RECEIVE_PAYMENTS = "radiotherapy/receive/payment/"
    static IP_SAFETY_DEPOSIT_RECEIVE_PAYMENT = "ip/safety-deposit/details/"

    // lab home api
    static LAB_STATUS_AND_TEST_REPORT_AMOUNT_GET = "lab/admission/bill/"
    static REVERT_LAB_URL = "ip/revert/laboratory/";
    static COMMON_BARCODE_PRINT = "fo/patient/label/print/"
    static SPECIMEN_BARCODE_PRINT = 'lab/specimen/collection/barcode/'
    static LAB_PRE_SPECIMAN_COLLECTED = "lab/pre/specimen/collection/"
    static LAB_POST_SPECIMAN_COLLECTED = "lab/post/specimen/collection/"
    static LAB_TEST_CONSUMABLE = "lab/test/consumable/"
    static LAB_CANCEL_BILL = "lab/bill/cancel/new/"
    static LAB_TEST_REPORT_PRINT = "lab/bill/report/"
    static LAB_PATIENT_RESULT_PRINT_HISTORY = "lab/test/report/history/print/"

    static FO_CREDIT_BILLS_GET = 'fo/pending/bills/'
    static GET_CORPORATE_CLAIM_DETAILS = "fo/corporate/claim-detail/"
    static GET_PRINT_PREVIEW = "ot/billing/tranaction/list/"
    static PHARMACY_INVOICE_PRINT = "pharmacy/billing/"
    static FO_OPTOMETRIST_LIST = "fo/optometrist/list/"
    static LAB_CREATE_PATIENT_DETAILS = "lab/create/patient/profile/"
    static LAB_SEARCH_PATIENT = "lab/patient/search/"
    static LAB_PATIENT_TRANSMIT_SEARCH = "lab/home/patient/search/"
    static LAB_PATINET_TEST_REPORT = "lab/result/completed/"
    static LAB_PATIENT_RESULT_PUT = 'lab/test/result/'
    static LAB_PATIENT_RESULT_PRINT = "lab/test/report/print/"
    static WHATSAPP_SEND = 'core/ebill/whatsapp/'
    static LAB_CLINIC_LIST_GET = "lab/clinic/data/"
    static LAB_FOR_TECHNICIANS_NEW = "lab/test/technician/new/"
    static LAB_OUTSOURCE_LIST = "lab/outsource-list/"

    static CURRENT_API_URL_LAB = "ip/revert/laboratory/";
    static LOG_API_URL_LAB = "ip/admin/laboratory-revert/";
    static PERFORM_LAB_URL = "ip/admin/laboratory-revert/";
    static OP_IP_SERVICE_HEAD_WISE_REPORT = 'fo/op-ip-serviceheadwise/report/'
    static LAB_OUTSOURCE_TRANSIT_SUG = 'lab/outsource/transit_detail/'
    static NEW_LAB_PACKAGE_CONFIGURATION = 'lab/package/'
    static EXPENSE_BILL_GET = "doctorv4/expense/bill/report/"
    static PHARMACY_USER_DAYEND_SALES = 'pharmacy/day/end/denomination/'
    static EXPENSE_CATEGORY_GET = "doctorv4/expense/category/"

    static SMS_SEND = 'core/ebill/sms/'
    static LAB_PATIENT_RESULT_GET = "lab/test/result/"
    static LAB_COMPLETED_TEST = "lab/test/completed/"
    static LAB_CULTURE_TEST_CONFIG = "lab/culture/"
    static LAB_PATIENT_TEST_HISTORY = 'lab/patient/test/history/'
    static LAB_PATIENT_OUTSOURCE_PATCH = "lab/test/result/"
    static NEW_CHANGE_PAYMENT_MODE = "billing/change/receipt/payment-mode/"
    static LAB_DOCTOR_REPORT_PRINT = "lab/doctor/report/"
    static LAB_PATIENT_OUTSOURCE_PRINT = "lab/report/outsource/"

    // Radiology api start
    static RAD_SERVICE_CONFIG = 'radiology/service/config/'
    static INVESTIGATION_TEST_TEMPLATE_CONFIG_NEW = 'investigation/service/template/config/new/'
    static RAD_TEST_TEMPLATE_CONFIG_NEW = 'radiology/service/template/config/new/'
    static PRINT_CONFIG = "core/printconfig/"
    static PRINT_HISTORY = "core/printconfig/history/"
    static NEW_RAD_RECEIPT_BILL_TRANS_GET = 'radiology/receipt-bill/transactions/new/'
    static NEW_RAD_OVER_ALL_BILL_TRANS_GET = 'radiology/overall/transactions/new/'
    static NEW_RAD_CREDIT_BILL_TRANS_GET = 'radiology/credit-bill/transactions/new/'
    static NEW_RAD_DAY_END_BILL_TRANS_GET = 'radiology/day/end/new/'
    static NEW_RAD_SAVED_BILL_TRANS_GET = 'radiology/saved-bill/transactions/new/'
    static NEW_RAD_CANCEL_BILL_TRANS_GET = 'radiology/cancel-bill/transactions/new/'

    static NEW_INVESTIGATION_RECEIPT_BILL_TRANS_GET = 'investigation/receipt-bill/transactions/new/'
    static NEW_INVESTIGATION_OVER_ALL_BILL_TRANS_GET = 'investigation/overall/transactions/new/'
    static NEW_INVESTIGATION_CREDIT_BILL_TRANS_GET = 'investigation/credit-bill/transactions/new/'
    static NEW_INVESTIGATION_DAY_END_BILL_TRANS_GET = 'investigation/day/end/new/'
    static NEW_INVESTIGATION_SAVED_BILL_TRANS_GET = 'investigation/saved-bill/transactions/new/'
    static NEW_INVESTIGATION_CANCEL_BILL_TRANS_GET = 'investigation/cancel-bill/transactions/new/'

    static IP_PATIENT_ADMISSION_PRINT = "ip/ipadmission/print/"
    static INVESTIGATION_PATIENT_APPOINTMENT_LIST = 'investigation/home/view/new'
    static RAD_NOTES = 'radiology/patient/notes/'
    static INVESTIGATION_NOTES = 'investigation/patient/notes/'
    static INVESTIGATION_RESULT_GET = 'investigation/billing/result/'
    static INVESTIGATION_RESULT_GET_NEW = 'investigation/billing/result/new/'
    static RAD_RESULT_GET = 'radiology/billing/result/'
    static RAD_RESULT_GET_NEW = 'radiology/billing/result/new/'
    static REVERT_RADIOLOGY_URL = "ip/revert/radiology/"

    // NEW REPORT CORPORATE 
    static NEW_FO_REPORTS_CORPORATE_PATIENT = "fo/corporate/patient/report/new/"

    // FO BILL TRANSACTION
    static NEW_DAY_END_REPORT_CARD = 'fo/new/day-end/summary/'
    static NEW_DAY_END_REPORT = 'fo/new/day-end/'
    static NEW_OVERALL_BILLS_GET = "billing/overall/"
    static DAY_END_USER_DETAIL_GET = "fo/user/list/config/"
    static INSURANCE_BILL_GET = "ip/insurance/bill/"
    static CORPORATE_PROVIDER_GET = "ip/corporate/provider/"
    static CORPORATE_PROVIDER_INFO_GET = "ip/corporate/provider/info/"
    static CORPORATE_BILL_GET = "ip/corporate/bill/"
    static COMMON_CREDIT_PAYMENT_POST = "ip/credit/settlement/receive-payment/"
    static ORDER_BILLS_GET = "billing/reports/order/list/"
    static FO_GET_APPOINMENT_DETAILS = "fo/appointment/details/"
    static FO_GET_IP_ADMISSION_DETAILS = "ip/admission/details/"
    static IP_PATIENT_INDIVIDUAL_SAVED_BILL = "ip/saved/bill/list/"
    static LAB_SAVED_BILL_DELETE = "lab/bill/cancel/new/"
    static USER_ACCESS_GET_LIST = "fo/user/access/list/"
    static DAY_END_STATUS_Filter = "doctor/billing/transaction/"
    static FO_DAY_END_COLLECTION_REPORT = 'reports/report/fo_collection_overview/'
    static RADIOLOGY_PRINT = 'radiology/create/bill/'
    static GET_ADVANCE_ADDED = 'pharmacy/advance-added/report/'

    // pharmacy api 
    static PHARMA_CONFIG_SETTINGS = "pharmacy/config/"
    static PHARMACY_OVERALL_BILL_LIST = "pharmacy/overall/bill/list/"
    static PHARMA_BILL_TOKEN_PRINT = 'pharmacy/bill-token/print/'

    // fo reports
    static FO_CONFIG_OPSRCNAME = "fo/service/config/new/"
    static FO_REPORTS_CORPORATE_PAYMENT = "fo/corporate/summary/report/"
    static FO_REPORTS_APPOINTMENT_PATIENT = "fo/patient/appointment/report/"
    static FO_REPORTS_APPOINTMENT_DOCTOR = "fo/doctor/appointment/report/"
    static FO_REPORTS_APPOINTMENT_SPECIALIZATION = "fo/speciality/appointment/report/"
    static FO_REPORTS_APPOINTMENT_TYPE = "fo/appointment/type/report/"
    static FO_REPORTS_TAT = "fo/tat/report/"
    static FO_REPORTS_TAT_DETAILED_VIEW = "fo/tat/timereport/"
    static FO_REPORTS_COUNSELLOR_SURGERY = "fo/counsellor-surgery/report/"
    static FO_COUNSELLOR_GET = "fo/counsellor/list/"
    static FO_IMA_REGISTRATION = 'fo/ima/'
    static FO_REPORTS_REQUEST_APPOINTMENT = "fo/appointment/request/report/"
    static FO_REPORTS_DEMOGRAPHICS = "fo/patient/demographic/report/"
    static FO_REPORTS_REASON_DIAGNOSIS = "fo/complaints/diagnosis/view/"
    static FO_REPORTS_REFERRAl_DETAIL = "fo/referral/detail/"
    static FO_REPORTS_REFERRAL_COUNT = "fo/referral/count/"
    static FO_REPORTS_REFERRAL_PATIENT_COUNT = 'fo/referral/patient/count/report/'
    static FO_REPORTS_PURPOSEOFVISIT = "fo/patient/pov/view/"
    static FO_CONFIG_IPSRCNAME = "ip/service/configuration/"

    // FO Billing
    static BILLING_ORDER_LIST = 'billing/op/appointment/order/view/'
    static BILLING_ORDER_LIST_IP = 'billing/ip/admission/order/view/'

    // pharmacy settings
    static PHARMA_GENERIC_NAME_LIST = "pharmacy/generic_name/registry/"
    static PHARMA_ADD_DOCTOR = "pharmacy/referred/doctor/"
    static PHARMA_EXTERNAL_DOCTOR = 'pharmacy/pharmacy-referred-doctor/'
    static PHARMA_SUB_LOCATION = "pharmacy/sublocation/view/"
    static PHARMA_STOCK_CORRECTION_LIST = "pharmacy/inventory/stock_adjustment/"
    static PHARMA_STOCK_CORRECTION_HISTORY = "pharmacy/inventory/stock_adjustment/history/"

    // branch to branch 
    static PHA_BRANCH_TOLOC = 'pharmacy/org/pharmacy/'

    //Inventory
    static LIST_STOCK = "pharmacy/stock-list/"
    static PHARMACY_SUBLOC_STOCKLIST = 'pharmacy/sub_loc/stock/list/view/'
    static PHARMA_INVENTORY_EDIT_DRUG_POST = 'pharmacy/druglist/update/'
    static PURCHASE_MANUFACTURER_GET = "pharmacy/manufacturer_list/"
    static PHARMA_DOCTOR_LIST = "pharmacy/billing/doctor/list/"

    static PHARMA_DOSAGE_TYPE_LIST = "pharmacy/dosage-types/"
    static ACTIVE_DRUG_LIST = "pharmacy/new/druglist/"
    static PHARMA_GENERIC_NAME_LIST = "pharmacy/generic_name/registry/"
    static PHARMA_ADD_NEW_DRUG = "pharmacy/drug/registry/"
    static PHARMA_STOCK_DETAILS = "pharmacy/stock-details/"
    static PHARMA_STOCK_RETURN_POST = "pharmacy/mark-return/"
    static PHARMA_ACTIVE_DRUG_POST = "pharmacy/new/druglist/status/"

    // pharmacy stock transfer
    static PHA_BRANCH_DRUGWISE_STOCKTRANSFER_REPORT = 'pharmacy/b2b/drugwise/list/'
    static PHARMA_BILLING_BRAND_SEARCH = 'pharmacy/drugs/search/'

    // sublocation module
    static SUBLOC_LOCATION_DETAILS = 'sublocation/module-list-new/'
    static SUBLOC_LINE_OF_ITEM = 'sublocation/inbound/stock-line/'
    static SUBLOC_STATUS_CHANGE = 'sublocation/request/status/'
    static SUBLOC_STOCK_TRANSFER = 'sublocation/stock-transfer/'
    static SUBLOC_OUTBOUND = 'sublocation/stock-outbound/'
    static PHARMACY_SUBLOC_STOCKLIST = 'pharmacy/sub_loc/stock/list/view/'
    static SUBLOC_DRUG_SEARCH = "sublocation/drug/search/"
    static SUBLOC_TRANSIT_DETAILS = 'sublocation/transit/details/'
    static SUBLOC_PATIENT_SEARCH = "sublocation/search/"
    static SUBLOC_BATCH_DETAILS_SEARCH = "sublocation/drug/details/"
    static SUBLOC_EXPIRY_STOCK = 'sublocation/expiry/'
    static SUBLOC_FROM_LOCATION_GET = 'sublocation/module-list/'
    static SUBLOC_REQUEST_DRUG_LIST_GET = 'sublocation/drug-list/'
    static SUBLOC_STOCK_RETUEN_REQUEST_GET = 'sublocation/stock-return/'
    static SUBLOC_STOCK_TFR_WANTED_LIST_GET = 'sublocation/wanted-list/'
    static SUBLOC_CONSUMPTION_REPORT_GET = 'sublocation/consumption/'
    static SUBLOC_CREDIT_REPORT_GET = 'sublocation/credit/report/'
    static SUBLOC_CREDIT_INDIVIDUAL_REPORT_GET = 'sublocation/credit/report/list/'
    static SUBLOC_STOCK_EXPIRY_REPORT_GET = 'sublocation/stock/expiry/view/'
    static SUBLOC_STOCK_LIST_REPORT_GET = 'sublocation/stock/list/view/'
    static SUBLOC_STOCK_LIST_HISTORY_GET = 'sublocation/stock/correction/history/'
    static SUBLOC_STOCK_VALUE_DETAIL = 'sublocation/stock/value/'


    // store module
    static STORE_STOCK_TRANSFER_REPORT = 'store/stock/transfer/report/'

    // branch to branch transfer
    static PHA_BRANCH_WANTED_LIST = 'pharmacy/b2b/wanted/list/'
    static PHA_BRANCH_REQ_POST = 'pharmacy/stock/transfer/'
    static PHA_BRANCH_LINE_OF_ITEM = 'pharmacy/inbound/line/'
    static PHA_BRANCH_TOLOC = 'pharmacy/org/pharmacy/'
    static PHA_BRANCH_STATUS_CHANGE = 'pharmacy/request/status/'
    static PHA_BRANCH_TRANSIT = 'pharmacy/transit/details/'
    static PHA_BRANCH_STOCK_REPORT = 'pharmacy/stock/transfer/list/'
    static PHA_BRANCH_STOCK_LIST = 'pharmacy/stock/list/'
    static SAVED_BILL_HOME = "pharmacy/partially/saved/bills/list/"
    static SUBLOC_SAVED_BILLS_GET = 'sublocation/billing/list/'
    static PHA_BRANCH_DRUGSEARCHLIST = 'pharmacy/global/drug/list/'
    static PHA_BRANCH_DRUGSEARCH = 'pharmacy/global/drug/search/'

    // pharmacy billing
    static PHARMA_SAVED_BILL_GET = "pharmacy/partial/billing/"
    static PHARMA_BILLING_RECEIVE_PAYMENT_POST = "pharmacy/billing/new/"
    static SUBLOC_GENERIC_CONSUMP_POST = "sublocation/consumption/"
    static PHARMA_DOCTOR_LIST = "pharmacy/billing/doctor/list/"
    static PHARMA_SAVED_BILL_DELETE = "pharmacy/partially/saved/bill/"
    static PHARMA_SALES_BILL_PRINT = "pharmacy/sales-bill/print/"
    static PHARMA_PATIENT_DETAILS_GET = "pharmacy/search/patient/"
    static PHARMA_BILLING_CREDIT_POST = 'pharmacy/credit/billing/'
    static PHARMA_BILLING_DRUG_DETAILS_GET = 'pharmacy/billing/drug/details/'
    static PHARMACY_BULK_RETURN_POST = 'pharmacy/billing/ip/return/'
    static PHARMA_RETURN_DRUG_GET = 'pharmacy/return/drugs/search/'
    static PHARMA_RETURN_BILLING_DRUG_DETAILS_GET = 'pharmacy/billing/drugs/'
    static PHARMA_PATIENT_ADMISSION_HISTORY = 'pharmacy/patient/appointment/history/'

    // Pharmacy Internal Store
    static INTERNALSALES_WANTEDLIST = "pharmacy/all/wanted/list/"
    static INTERNALSALES_WANTEDLISTDetail = "pharmacy/wanted/list/"
    static INTERNALSALES_REQUESTLIST = "pharmacy/store/request/list/"
    static INTERNALSALES_DRUGSTOCK_DETAILS = "pharmacy/store/drug/search/"
    static INTERNALSALES_SEND_REQUEST_LIST = "pharmacy/store/request/list/"
    static INTERNALSALES_SALES_REPORT = "pharmacy/internal/sales/report/"
    static INTERNALSALES_TAX_REPORT = "pharmacy/internal/tax/report/"
    static INTERNALSALES_INVOICE_REPORT = "pharmacy/invoice/report/"
    static INTERNALSALES_MONTHWISE_INVOICE_REPORT = "pharmacy/invoice/report/"
    static INTERNALSALES_PO_RECEIVE = "pharmacy/store/po/receive/"

    // Pharmacy Purchase Order
    static PURCHASE_ORDER_PO_REQUEST_LIST = "pharmacy/purchase/request/list/"
    static PURCHASE_PLACEORDER_POST = "pharmacy/purchase-order/"
    static PURCHASE_BRAND_NAME_GET = "pharmacy/po/drugs/search/"
    static PURCHASE_VENDOR_LIST = "pharmacy/vendors/list/"
    static PURCHASE_ORDER_LIST = "pharmacy/purchase-orders/list/"
    static PURCHASE_PO_DETAILS_GET = "pharmacy/stock/entry/items/"
    static PHARMACY_PO_CANCEL = "pharmacy/purchase/order/cancel/"
    static PURCHASE_DIRECT_PO_POST = "pharmacy/direct/po/"
    static PURCHASE_DC_POST = "pharmacy/dc_entry/"
    static PHARMA_PO_REQUEST_PRINT = 'pharmacy/purchase-order/'
    static PURCHASE_PO_NUMBER_GET = "pharmacy/po-number/get/"
    static PURCHASE_ADD_TO_STK_POST = "pharmacy/add/to/stock/"
    static PURCHASE_VENDOR_PAYMENT = "pharmacy/vendor/payment/transaction/"
    static PURCHASE_VENDOR_PAYMENT_PRINT = "pharmacy/vendor/payment/transaction/detailed/"
    static PURCHASE_VENDOR_MONTHLY = "pharmacy/vendor/payment/transaction/month/"
    static PURCHASE_VENDOR_MONTHLY_POST = "pharmacy/vendor/payment/"
    static PHARMA_NEW_VENDOR_PAYMENT = 'pharmacy/vendor/po/'
    static PHARMA_NEW_VENDOR_RECEIPT = 'pharmacy/vendor/receipt/'
    static PO_RETURN = 'pharmacy/po/return/'
    static PHARMA_PURCHASE_RTN_PRINT = 'pharmacy/po/return/'
    static PURCHASE_VENDOR_ADD = "pharmacy/vendor/"
    static PHARMA_PURCHASE_REJECTION_PRINT = 'pharmacy/purchase_rejection/lineitem_print/'
    static PURCHASE_BATCH_DETAILS_GET = "pharmacy/po/drug-details/"
    static PURCHASE_DRUG_DETAILS_GET = "pharmacy/drug-details/"
    static PURCHASE_PREVIOUS_PRICE_GET = "pharmacy/get/previous-drug-details"
    static PURCHASE_BATCH_LIST_POST = "pharmacy/batch/list/"
    static PHARMA_CREDIT_NOTE_REPORT = 'pharmacy/credit-note/po-return/'
    static PURCHASE_WANTED_LIST = "pharmacy/wanted/list/"
    static PURCHASE_WANTED_LIST_CART = "pharmacy/wanted/list/cart/"
    static PURCHASE_CONFIRM_ORDER_LIST = "pharmacy/order/list/"
    static PURCHASE_CONFIRMORDER_POPUP = "pharmacy/product/list/order/"
    static PURCHASE_CONFIRMORDER_PRINT = "pharmacy/confirm_order/print/"
    static PHARMA_PO_CREDIT_NOTE_POST = 'pharmacy/credit-note/po-return/'

    static INDENT_REQ_COUNT = 'pharmacy/indent/batch/'
    static PURCHASE_VENDOR_LIST = "pharmacy/vendors/list/"
    static STORE_VENDOR_PAYMENT = 'store/vendor/payment/'
    static PURCHASE_VENDOR_PAYMENT = "pharmacy/vendor/payment/transaction/"
    static PURCHASE_VENDOR_PAYMENT_PRINT = "pharmacy/vendor/payment/transaction/detailed/"
    static PHARMA_PO_CREDIT_NOTE_VENDOR_GET = 'pharmacy/po-return/new/'

    // Pharmacy Reports
    static PHARMA_INVENTORY_STOCK_VALUE_REPORT_GET = 'pharmacy/stockvalue/report/'
    static ISSUED_DRUG_REPORT = "billing/issue/drug/report/"

    // Pharmacy Invoice
    static PHARMACY_OVERALL_BILL_LIST = "pharmacy/overall/bill/list/"
    static PHARMACY_CREDIT_BILL_LIST = "pharmacy/credit/billing/transaction/"
    static PHARMACY_PATIENT_CREDIT_BILL = "pharmacy/credit/billing/"
    static PHARMACY_SAVED_BILL_LIST = "pharmacy/saved/bill/new/"
    static PHARMACY_RECEIPT_BILL_LIST = "pharmacy/receipt/bills/"
    static PURCHASE_BATCHNO_GET = "pharmacy/po-return/drug-detail/"
    static PURCHASE_RETURN_POST = "pharmacy/po-return/new/"
    static PURCHASE_MANUFACTURER_GET = "pharmacy/manufacturer_list/"

    //store
    static STORE_VENDOR_PAYMENT = 'store/vendor/payment/'
    static STORE_VENDOR_PAYMENT_MONTHLY = 'store/vendor/po/payment/'
    static STORE_VENDOR_PAYMENT_RECEIPTS = 'store/vendor/payment/receipts/'
    static STORE_VENDOR_PAYMENT_RECEIVE = 'store/vendor/payment/receive/'

    //Pharmacy Home 
    static PHARMA_PRESCRIPTION_HISTORY = "pharmacy/invoice/history/"
    static PHARMA_PRESC_LIST_HISTORY_GET = 'pharmacy/prescriptions/list/'
    static PHARMA_PRESCRIPTION_GET = "pharmacy/prescription/"
    static PHARMA_RETURN_BILL = "pharmacy/bill/return/new/"
    static IP_RETURN_HOME = "pharmacy/medication/return/list/"
    static IP_REQUEST_HOME = "pharmacy/medication/list/"
    static APPOINTMENT_HOME = "pharmacy/appointments/list/"
    static IP_ADMISSION_LIST_HOME = "pharmacy/ipadmission/list/"
    static PRESCRIPTION_HOME = "pharmacy/transmitted/prescription/list/"
    static IP_LIST_ALL_STATUS = 'fo/ipadmission/list/'

    // Fo Ip Home
    static FO_IP_HOME = "ip/home/ipappoinment/"
    static FO_IP_HOME_STATUS = "ip/home/ipappoinment/new/"
    static IP_DETAILED_PRINT_FO = "billing/ip-detailed-print/"
    static IP_ADMISSION_BILL_APPROX_PRINT = "ip/approx/bill/print/"
    static IP_LABEL_LAYOUT_CONFIG = "fo/ip-label/print-configuration/"
    static IP_LABEL_PRINT = "fo/ip-label/"
    static IP_PATIENT_DATA_PRINT = "ip/patient/data/"
    static ATTENDER_CARD_PRINT = 'fo/attender-card/'
    static IP_PATIENT_DISCHARGE_SLIP = "ip/dischage-summary/slip/"
    static IP_DISCHARGE_APPROVAL = "ip/discharge-approval/"
    static REVERT_DISCHARGE_URL = "ip/revert/discharge/"
    static CHANGE_ADMISSION_TYPE = "ip/revert/admissionType/";
    static FO_PATIENT_RESERVATION = 'ip/reserved/ward-detail/'
    static TPA_List = "ip/tpa/list/"
    static FO_INSURANCE_LIST = "fo/insurance/list/"
    static FO_RESERVATION_FILTER_GET = "ip/patient/attender/reservation/"
    static IP_RESERVATION_PAYMENT = "ip/reserved/reciept-detail/"
    static CUSTOM_BARCODE_CONFIG = "fo/custom-barcode-config/"
    static ATTENDER_CARD_CONFIG = 'fo/attender-card/print-configuration/'
    static ATTENDER_CARD_PRINT = 'fo/attender-card/'
    static ADMISSION_HISTORY_GET = "fo/appointment/history/"
    static IP_APP_PRINT = "ip/admission/list/print/"
    static IP_ESTIMATE_BILL_GET = "ip/estimate/bill/"
    static IP_ESTIMATE_LIST_GET = "ip/estimate/list/"
    static IP_APPROX_AMOUNT = "ip/bill-value/"
    static FO_IP_CLINICAL_NURSE_NOTES = "ip/nursenotes/"
    static IP_STATION_NURSE_LIST = "ip/station/nurse-list/"
    static IP_NURSE_VITAL_TASK = "ip/nurse/vital-task/"
    static IP_NURSE_SPECIAL_TASK = "ip/nurse/special-task/"
    static IP_NURSE_SPECIAL_TASK_TREATMENT_LOG = "ip/nurse/special-task/treatment-log/"
    static IP_TASK_PATIENT_LIST = "ip/task/patient-list/"
    static IP_PATIENT_NURSE_TASKS = "ip/patient/nurse-tasks/"
    static IP_VITAL_TASK_UPDATE_LOG = "ip/vital-task/update/log/"
    static IP_NURSE_MEDICINE_TASK = "ip/nurse/medicine-task/"
    static IP_PATIENT_PHARMACY_STOCK = "ip/patient/pharmacy-stock/"
    static IP_REFILL_REQUEST_LOG = "ip/refill-request/log/"
    static IP_MEDICATION_DETAILS = "ip/medication/details/"
    static IP_MEDICATION_DRUG_CHART = "ip/medication/drug-chart/"
    static IP_MEDICATION_TRANSMIT_LIST = "ip/medication/transmit-list/"
    static IP_MEDICATION_TRANSMIT_DRUG_DETAIL = "ip/medication/transmit-drug-detail/"
    static IP_PATIENT_CHECKLIST = "ip/patient/checklist/"
    static IP_CHECKLIST_MASTER = "ip/checklist/master/"
    static IP_DOC_NUTRITION_CHART_TEMPLATE = "ip/nutrition/chart/template/"
    static IP_DOC_NUTRITION_CHART = "ip/nutrition/chart/"
    static FO_IP_LABLIST = "ip/lab/list/"
    static IP_SUR_NOTE_TEM = "ip/surgery/layout/template/"
    static IP_SN_CREATE = "ip/surgery/notes/create/"
    static SUR_NOTE_PRINT = "ip/surgery/notes/print/"
    static FO_CONFIG_CORPORATE = "fo/corporate/detail/";
    static FO_INSURANCE_LIST = "fo/insurance/list/"
    static IP_PATIENT_DETAILS_NEW = "ip/patientheader/new/"
    static POST_PATIENT_CREDIT_TYPE = 'ip/patient/credit-type/'
    static PRE_AUTHORIZATION_POST = 'ip/pre-auth/claim/'
    static IP_PAIN_CHART = "ip/painchart/"
    static DOC_BLOOD_MENSURAL_HISTORY_GET = 'doctorv4/diabetic/menstrual-history/'
    static FO_IP_MODIFY_BILL_GET = 'ip/final/bill/modify-log/'

    // Discharge Summary
    static IP_DIS_SUM_CATAGORY = "ip/discharge/summary/category/config/"
    static IP_TEMPLATE_DIS_SUM = "ip/discharge/summary/template/"
    static DIS_SUM_LAYOUT = "ip/discharge/summery/"
    static IP_DOCNOTES_PROVISIONAL_DIAG = 'ip/diagnosisnotes/'
    static IP_DIS_SUM_TEM = "ip/discharge/layout/template/"

    // JMO - ClINICAL STAFF
    static JMO_CLINICAL_STAFF_GET = 'doctorv4/clinical-staff/'
    static JMO_CLINICAL_STAFFMAP_GET = 'doctorv4/doctor-clinical-staff/'
    static JMO_APPOINTMENT_GET = 'doctorv4/appointment/list/'
    static JMO_DOCTOR_LIST_GET = 'doctorv4/jmo/linked-doctors/'
    static IP_DOCNOTES_DIAGNOSIS = 'ip/diagnosis/'
    static GET_ICD_CODE = "ip/icdcode/search/"
    static IP_DISCHARGE_SUMMARY_HISTORY_LOG = "ip/discharge/summary/log"
    static FO_IP_DISCHARGE_SUMMARY_INVESTTEST_NEW = "ip/discharge/summery/investigationtest/new/"
    static IP_DIS_SUM_POST = "ip/discharge/summary/"
    static IP_DIS_SUM_COPY_DATA = "ip/dischage-summary/copy/"
 
    //PHARMACY ===> URL'S STARTS
    // Pharmacy Sales Report
    static PHARMA_SALES_OVERVIEW_REPORT_GET = 'pharmacy/reports/sales/overview/'
    static PHARMA_SALES_DETAILED_REPORT_GET = 'pharmacy/reports/sales/detailed/'
    static PHARMA_SALES_RETURN_REPORT_GET = 'pharmacy/sales/return/report/new/'
    static PHARMA_SALES_MONTHLY_REPORT_GET = 'pharmacy/reports/sales/monthly/'
    static PHARMA_DAY_END_REPORT_GET = 'pharmacy/reports/sales/day-end/'
    static PHARMA_PRODUCT_WISE_SALE = 'pharmacy/product/sales/report/'
    static PHARMA_RETURN_TAX_WISE_SALES = 'pharmacy/sales/return/tax/report/'
    static SALES_RETURN_HSN_CODE_WISE = 'pharmacy/sales/return/hsn/report/'
    static SALES_RETURN_HSN_CODE_RATE_WISE = 'pharmacy/sales/return/hsn/tax/report/'
    static SALES_REPORTS_PROFITANALYSIS = 'pharmacy/profit/analysis/report/'
    static SALES_BILL_TAX_WISE = 'pharmacy/reports/sales/invoice/tax/'
    static PHARMA_USER_SALES_PERFORMANCE = 'pharmacy/user/performance/'
    static SALES_RETURN_HSN_DOSAGE_WISE = 'pharmacy/sales/return/hsn/dosage_type/report/'
    static PHARMA_TAX_WISE_SALES = 'pharmacy/tax/wise/report/'
    static PHARAMCY_SALES_HSN_WISE = 'pharmacy/hsn/wise/report/'
    static PHARMA_PRESCRIPTION_REG = 'pharmacy/prescription/register/'
    static GET_DICOUNT_REPORT_PHARMACY = 'pharmacy/reports/sales/discount/new/';
    static DOOR_DELIVERY_REPORT = "pharmacy/billing/door-delivery/"
    static ISSUED_DRUG_REPORT = "billing/issue/drug/report/"

    //Purchase Report
    static PHARMA_PURCHASE_OVERVIEW_REPORT_GET = 'pharmacy/reports/purchase/overview/'
    static PHARMA_PURCHASE_DETAILED_REPORT_GET = 'pharmacy/reports/purchase/detailed/'
    static PHARMA_PURCHASE_RETURN_REPORT_GET = 'pharmacy/reports/purchase-return/'
    static PHARMA_PURCHASE_MONTHLY_REPORT_GET = 'pharmacy/reports/purchase/monthly/'
    static PHARMA_PURCHASE_CONSOLIDATED_REPORT_GET = 'pharmacy/consolidate-report/'
    static PHARMA_PURCHASE_BILL_TAXWISE_GET = 'pharmacy/reports/purchase/invoice/tax/'
    static PHARMA_PURCHASE_BILL_RETURN_TAXWISE_GET = 'pharmacy/reports/purchase/return/invoice/tax/'
    static PHARMA_PURCHASE_GST = "pharmacy/purchase/gst/report/new/"
    static PHARMA_VENDOR_BILL = 'pharmacy/vendor-purchase/report'
    static PHARMA_HSN_REPORT = 'pharmacy/reports/purchase/hsn/'
    static PHARMA_PURCHASE_RETURN_HSN_REPORTS = 'pharmacy/reports/purchase/return/hsn/'
    static PHARMA_PURCHASE_RETURN_VENDOR_REPORTS = 'pharmacy/vendor/po-return/report/'
    static PURCHASE_WISE_ENQUIRY = "pharmacy/product/wise/report"

    //Pharmacy Inventory Report
    static PHARMA_INVENTORY_STOCK_OVERVIEW_REPORT_GET = 'pharmacy/reports/stock/'
    static PHARMA_INVENTORY_BRAND_GET = 'pharmacy/drugs/auto-complete/'
    static PHARMA_INVENTORY_GENERIC_GET = 'pharmacy/drug-details/'
    static PHARMA_INVENTORY_VENDOR_GET = 'pharmacy/vendor/search/'
    static PHARMA_INVENTORY_MIS_REPORT_GET = 'pharmacy/reports/mis-report/'
    static PHARMA_INVENTORY_EXPIRY_STOCK_REPORT_GET = 'pharmacy/reports/drug-expiry/'
    static PHARMA_INVENTORY_LOW_STOCK_REPORT_GET = 'pharmacy/reorder/threshold/'
    static PHARMA_INVENTORY_STOCK_CORRECTION_REPORT_GET = 'pharmacy/stock_correction/report/'
    static PHARMA_INVENTORY_STOCK_VALUE_REPORT_GET = 'pharmacy/stockvalue/report/'
    static PHARMA_INVENTORY_EDIT_DRUG_POST = 'pharmacy/druglist/update/'
    static PHARMA_STOCK_EDIT_LOG = 'pharmacy/stock-edit-log/'
    static PHARMA_NO_AND_SLOW_MOVEMENT_REPORT = "pharmacy/no-slow/movements/new/"

    static USER_ACCESS_CONFIGURATION = "fo/user/access/"
    static USER_ACCESS_GET_MODULES = "fo/lincked/modulelist/"
    static FO_CONFIG_USER_CONFIGURATION = 'fo/user/list/config/'
    static RESET_PASSWORD = 'auth/reset/password/'
}